import { render, staticRenderFns } from "./addOrEditGoods.vue?vue&type=template&id=705f0832&scoped=true"
import script from "./addOrEditGoods.vue?vue&type=script&lang=js"
export * from "./addOrEditGoods.vue?vue&type=script&lang=js"
import style0 from "./addOrEditGoods.vue?vue&type=style&index=0&id=705f0832&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f0832",
  null
  
)

export default component.exports